/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_View_DetailInputs */

const vi_care_log_view_detail = /** @type {(inputs: Care_Log_View_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem chi tiết nhật ký`)
};

/**

* @param {Care_Log_View_DetailInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_view_detail = /** @type {((inputs?: Care_Log_View_DetailInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_View_DetailInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_view_detail(inputs)
});